import { createContext, useContext, useState, useEffect } from 'react';

const PreferencesContext = createContext();

const load = (key, def) => {
  try { const v = localStorage.getItem(key); return v !== null ? JSON.parse(v) : def; }
  catch { return def; }
};

export function PreferencesProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => load('pref_darkMode', true));
  const [viewMode, setViewMode] = useState(() => load('pref_viewMode', 'card')); // 'card' | 'list'

  useEffect(() => {
    document.body.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    localStorage.setItem('pref_darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem('pref_viewMode', JSON.stringify(viewMode));
  }, [viewMode]);

  const toggleDarkMode = () => setDarkMode(d => !d);
  const toggleViewMode = () => setViewMode(v => v === 'card' ? 'list' : 'card');

  return (
    <PreferencesContext.Provider value={{ darkMode, toggleDarkMode, viewMode, toggleViewMode }}>
      {children}
    </PreferencesContext.Provider>
  );
}

export const usePreferences = () => useContext(PreferencesContext);
